﻿import { LiveDataSetStation } from "../API/LiveData/LiveDataSet";
import { WarningThreshold } from "../Formatters/IStationValueFormatter";
import { ParameterGroupInfo } from "../ParameterGroupInfoSet";
import { WarningRuleSet } from "./WarningRuleSet";

export interface WarningGroup {
    Id: string;
    Label: string;
    Rules: { [parameterGroup: string]: WarningRuleSet };    // userd for the old-style, simple server-side warning rule sets
    IsFrontEndWarningRuleSet: boolean;   // true for the new, front-end warning rule sets
}

export function GetWarningThreshold(warningGroup: WarningGroup, value: number, parameterGroupInfo: ParameterGroupInfo, station: LiveDataSetStation): WarningThreshold {

    if (warningGroup.IsFrontEndWarningRuleSet && warningGroup.Id in FrontEndWarningRules.map) {

        var ruleSet = FrontEndWarningRules.map[warningGroup.Id];

        return ruleSet.getWarningThreshold(parameterGroupInfo, value, station);

    } else if (parameterGroupInfo.Id in warningGroup.Rules) {

        // old-style server-side warning groups

        var rule: WarningRuleSet = warningGroup.Rules[parameterGroupInfo.Id];

        if ((rule.Gt_HighPriority !== null && value > rule.Gt_HighPriority)
            || (rule.Lt_HighPriority !== null && value < rule.Lt_HighPriority)) {
            return WarningThreshold.Level3;
        } else if ((rule.Gt_MediumPriority !== null && value > rule.Gt_MediumPriority)
            || (rule.Lt_MediumPriority !== null && value < rule.Lt_MediumPriority)) {
            return WarningThreshold.Level2;
        } else if ((rule.Gt_LowPriority !== null && value > rule.Gt_LowPriority)
            || (rule.Lt_LowPriority !== null && value < rule.Lt_LowPriority)) {
            return WarningThreshold.Level1;
        } else {
            return WarningThreshold.OK;
        }
    } else {
        return WarningThreshold.OK;
    }
}